// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { keyedReviver } = require('client-v2/common/state/revivers')
const { NextPageStateEnum } = require('client-v2/common/utils/enums')

class CollectionEditCoverImageModalRecord extends Immutable.Record({
  images: new Immutable.List(), // [ String, ... ]
  nextPageNumber: Number(1),
  nextPageState: NextPageStateEnum.AVAILABLE
}) {
  // No methods
}

CollectionEditCoverImageModalRecord.reviver = keyedReviver(CollectionEditCoverImageModalRecord, {
  // No nested data structures
})

module.exports = CollectionEditCoverImageModalRecord
